import fetch from 'auth/FetchInterceptor'

const AuthService = {}

AuthService.login = function (data) {
  return fetch({
    url: 'auth/login',
    method: 'post',
    silent: true,
    headers: {
      'public-request': 'true',
    },
    data,
  })
}

AuthService.logout = function () {
  return fetch({
    url: 'auth/logout',
    method: 'post',
    silent: true,
  })
}

AuthService.register = function (data) {
  return fetch({
    url: '/employer/register',
    method: 'post',
    silent: true,
    headers: {
      'public-request': 'true',
    },
    data,
  })
}

export default AuthService
